import { useQuery } from '@tanstack/react-query'
import { fetchJoinableNations, nationKeys } from '@/services/nations'

export function useJoinableNations() {
  const nationsQuery = useQuery({
    queryKey: nationKeys.joinable(),
    queryFn: () => fetchJoinableNations(),
  })

  return {
    nations: nationsQuery.data,
    isLoading: nationsQuery.isLoading,
    error: nationsQuery.error,
  }
}
